import { Firebaseconfig, CommProtocol, StompConfig } from '../../firebase';

export const Environment = {
  production: false,
  env: 'onpremises2',
  apiBaseUrl: window.location.origin + '/api', //window.location.origin+'/api',  // 'https://pidemo.impressicocrm.com/api',
  qmsBaseUrl: 'https://portal.signq.co.in',
  isMasterMockTrue: false,
  firebase: {
    /*apiKey: "AIzaSyDnvMZlW7rXxCBljEDAsYW1wpz1O0R5pfs",
    authDomain: "pi-fcm-impressico.firebaseapp.com",
    databaseURL: "https://pi-fcm-impressico.firebaseio.com",
    projectId: "pi-fcm-impressico",
    storageBucket: "",
    messagingSenderId: "980769801223"*/

    /*apiKey: "AIzaSyAwfxiMWVGXTFHIMoMi4U22wd52ZK1_WQw",
    authDomain: "pi-on-premises2.firebaseapp.com",
    databaseURL: "https://pi-on-premises2.firebaseio.com",
    projectId: "pi-on-premises2",
    storageBucket: "pi-on-premises2.appspot.com",
    messagingSenderId: "929247704838"*/

    apiKey: Firebaseconfig.apiKey,
    authDomain: Firebaseconfig.authDomain,
    // databaseURL: Firebaseconfig.databaseURL,
    projectId: Firebaseconfig.projectId,
    storageBucket: Firebaseconfig.storageBucket,
    recaptchaSiteKey: Firebaseconfig.captchaSiteKey,
    messagingSenderId: Firebaseconfig.messagingSenderId

  },
  stomp: {
    url: StompConfig.url,
    loginName: StompConfig.loginName,
    passcode: StompConfig.passcode
  },
  commProtocol: CommProtocol.sslType
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts